import React from 'react';
import styles from './InfoCardText.module.css';
import LeftSkewHeader from '../../components/LeftSkewHeader';
import LeftSkewPar from '../../components/LeftSkewPar';

interface InfoCardTextProps {
    headerText: React.ReactNode;
    descText: React.ReactNode;
    backgroundColor?: string;
    headerTextColor?: string;
    descTextColor?: string;
    reverseOnMobile?: boolean;
}

const InfoCardText: React.FC<InfoCardTextProps> = ({
    headerText,
    descText, 
    backgroundColor = '#FAFAF2',
    headerTextColor = '#003600',
    descTextColor = '#003600',
    reverseOnMobile = false,
}) => {

    const containerClassNames = `${styles.cardContainer} 
        ${reverseOnMobile ? styles.reverseOnMobile : ''
    }`;

    return (
        <div
            className={containerClassNames}
            style={
                {
                    '--background-color': backgroundColor
                } as React.CSSProperties
            }
        >
            {/* Left header (or top) container */}
            <div
                className={styles.cell}
            >
                <LeftSkewHeader
                    text={headerText}
                    textColor={headerTextColor}
                />
            </div>  
            <div
                className={styles.parCell}
            >
                <LeftSkewPar
                    text={descText}
                    textColor={descTextColor}
                />
            </div>
        </div>
    );
};

export default InfoCardText;